/*
 * This app's ONE session — who the user is, and what their org bought.
 *
 * The Session itself is base-ui's and shared by every Vitesse UI; this module is
 * where THIS app claims it, naming the surface it renders. That is the only part
 * that legitimately differs per app: an authored grant is scoped by surface, so
 * "may write from the app but not through the AI" is expressible.
 *
 * It lives here rather than in main/index.ts so a component can import it without
 * importing the boot module — importing boot from a component is a cycle, and the
 * usual way that gets "solved" is by not gating the component at all.
 *
 * ONE `initSession` call per app, and this is it. Identity is bound at boot with
 * `bindIdentity`; see main/index.ts. Most components need neither — `<vitesse-gated>`
 * resolves the same session on its own, so wrapping is enough.
 *
 * NO PLAN STREAM HERE, deliberately. Every gated fleet-control RPC is guarded by a
 * PERMISSION (org:gateway:claim / remove / rename / unclaim), which rides in the
 * the IdP identity and is available synchronously. Nothing this app renders is gated
 * on a purchased capability, so subscribing to entitlements would add a stream
 * whose answer nothing reads. When something here does become capability-gated,
 * feed `session.setPlan` the same way the gateway app does.
 */
import { initSession } from '@vitesse/base-ui';

export const session = initSession();
